import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H1Font from "Root/profile/components/common/H1Font";
import Arrow from "Images/profile/rightArrow.svg";
import styles from "./styles.module.scss";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { CSSTransition } from "react-transition-group";
import React, { useEffect, useState } from "react";
const TargetResultsBanner = ({ products }) => {
    const [showImages, setShowImages] = useState(false);
    const isMobile = useScreenWidth() < 968;
    const scrollDown = () => {
        const elem = document.getElementById("target_system");
        if (elem) {
            elem.scrollIntoView({ behavior: "smooth" });
        }
    };
    useEffect(() => {
        if (products.length > 0) {
            setShowImages(true);
        }
    }, [products]);
    return (_jsx("div", { className: styles.banner, children: _jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.selected_products, children: [_jsx(H1Font, { children: "Get To Know Your Gainful System" }), !isMobile && (_jsx("div", { className: `${styles.rounded_arrow}`, children: _jsx("img", { src: Arrow, alt: "left" }) }))] }), _jsx("div", { className: styles.images, children: products.map((item, i) => (_jsx(CSSTransition, { classNames: {
                            enter: styles["image-enter"],
                            enterActive: styles["image-enter-active"],
                            enterDone: styles["image-enter-done"],
                            exitActive: styles["image-exit-active"],
                            exitDone: styles["image-exit"],
                        }, timeout: (i + 1) * 1000 - 500, in: showImages, children: _jsx("div", { className: styles.img, children: _jsx("img", { src: item.tile_image, alt: "" }) }) }, item.product_id))) }), isMobile && (_jsx("div", { role: "button", tabIndex: 0, onKeyDown: () => null, onClick: scrollDown, className: `${styles.rounded_arrow}`, children: _jsx("img", { src: Arrow, alt: "left" }) }))] }) }));
};
export default TargetResultsBanner;
